<template>
    <div class="card widget widget-categories">
        <div class="widget__header">
            <h4>Categories</h4>
        </div>
        <ul class="widget-categories__list widget-categories__list--root" data-collapse data-collapse-opened-class="widget-categories__item--open">
            <!-- <li class="widget-categories__item" data-collapse-item>
                <a href="/category" class="widget-categories__link">
                    All Categories
                </a>
            </li> -->
            <li class="widget-categories__item"
                v-for="category in categories" :key="category.name"
                :class="(category.isOpen) ? 'widget-categories__item--open' : '' ">
                <router-link :to="toCategoryLink(category.DMCD01 + '/' + category.categoryname.replace(/ /g, '-'))" class="widget-categories__link" v-if="category.DSVEH != 'Y'">
                    <!-- <span class="widget-categories__link"> -->
                    {{category.categoryname}}
                    <!-- </span> -->
                </router-link>
                <a href="#" class="widget-categories__link" v-else @click="openVehicleDialog(category.DMCD01)">
                    {{category.categoryname}}
                </a>
                <!-- 
                    removed attribute: data-collapse-trigger 
                    changed by vue functionalities
                -->
                <button v-if="category.subcategories.length > 0" class="widget-categories__expander" type="button" @click="category.isOpen = !category.isOpen"></button>
                <div v-if="category.subcategories.length > 0" class="widget-categories__container">
                    <ul class="widget-categories__list widget-categories__list--child">
                        <li class="widget-categories__item" v-for="subcat in category.subcategories" :key="subcat.categoryname">
                            <router-link :to="toSubCategoryLink(subcat)" class="widget-categories__link" >
                                <!-- @click="$emit('filter_subcat', subcat)" -->
                            <!-- <a :href="toSubCategoryLink(subcat.uri)" class="widget-categories__link"> -->
                                {{subcat.categoryname}}
                            <!-- </a> -->
                            </router-link>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>

        <kit-vehicle-dialog @close="kitDialog = false" :open="kitDialog" :main_category="vehicle_category"></kit-vehicle-dialog>
    </div>
</template>


<script>
// import { mapGetters } from "vuex";
import KitVehicleDialog from '../kit-group/KitVehicleDialog.vue';


export default {
    components: {KitVehicleDialog},
    data() {
        return {
            kitDialog: false,
            vehicle_category: '',
            // categories : []
        }
    },
    computed: {
        categories() {
            let categories = this.$store.getters['product/format_category']
            categories.sort((a,b) => (a.categoryname > b.categoryname) ? 1 : ((b.categoryname > a.categoryname) ? -1 : 0));
            categories.forEach(item => {
                item.isOpen = false;
            });
            // console.log(categories);
            return categories;
            // return this.$store.getters['product/format_category'];
        }
        // ...mapGetters("product", ["categories"]),
    },
    methods: {
        openVehicleDialog(cat) {
            console.log('openVehicleDialog category = ' + cat);
            this.kitDialog = true;
            this.vehicle_category = cat;
        },
        toCategoryLink(uri) {
            if(uri != '')
                // return '/category/' + uri;
                return '/category/1/' + uri;
            else
                return '/category';
        },

        toSubCategoryLink(subcat) {
            const st_categories = this.$store.getters['product/categories'];
            const cat1 = st_categories.find((cat) => { return ((cat.DMCD01 === subcat.DMCD01) && (cat.categorylevel === 1));} );
            // console.log(subcat);
            if(subcat != ''){
                // console.log(this.$route.name);
                // if(this.$route.name == 'Category'){
                    return '/category/2/' + subcat.DMCD01 + '/' + subcat.DMCD02 + '/'  + cat1.categoryname.replace(/ /g, '-') + '/'  + subcat.categoryname.replace(/ /g, '-');
                    // return '/category-search/' + subcat.DMCD01 + '/'  + cat1.categoryname + '/'  + subcat.DMCD02;
                // }else{
                //     return '#'
                // }
                // this.$emit('filter_subcat', subcat.DMCD02);
                
                
            }else{
                return '/category';
            }
                
        }

    },

    created() {
    }

}
</script>